import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-action-button",
  templateUrl: "./action-button.component.html",
  styleUrls: ["./action-button.component.scss"],
})
export class ActionButtonComponent implements OnInit, OnChanges {

  @Input() options: {type: string; icon: string}[];
  @Input() selected: string;
  @Input() optionsPosition = "down";

  @Output() optionClick = new EventEmitter();

  selectedIcon: string;
  showButtons = false;

  constructor() { }

  ngOnInit() {
    this.selectedIcon = this.options.find(option => option.type === this.selected).icon;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.selectedIcon = this.options.find(option => option.type === changes.selected.currentValue).icon;
  }

  doShowButtons() {
    this.showButtons = !this.showButtons;
  }

  doChoose(choice) {
    this.showButtons = false;
    this.optionClick.emit(choice);
  }

}
